<template>
      <div no-body class="lku-ap2"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else >
        <b-col lg="12">
            <b-input-group >
                <b-input-group-prepend><label >Vendor</label></b-input-group-prepend>
                <b-form-input v-model="tblData.vendor" placeholder="Name"  @keyup.13.native="refresh()"></b-form-input>
                        <b-input-group-prepend><span class="mt-2" >Description</span></b-input-group-prepend>                  
                        <b-form-input v-model="tblData.uraian" @keyup.13.native="refresh()" placeholder="Description"></b-form-input>
            </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>Invoice Number </label></b-input-group-prepend>
                  <b-form-input v-model="tblData.invoice" @keyup.13.native="refresh()" placeholder="Invoice Number"></b-form-input>
                  <b-form-input v-model="tblData.nomor" @keyup.13.native="refresh()" placeholder="AP Number" class="ml-1"></b-form-input>
                <b-input-group-prepend><span class="pt-2 mr-1">Outstand.</span></b-input-group-prepend>
                <select  v-model="tblData.outstand"  style="width:60px;">
                    <option value="1">Yes</option><option value="0">No</option><option value="">-ALL-</option>
                </select>
                <b-input-group-append>
                    <b-button class="btn btn-success ml-3" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear </b-button>
                </b-input-group-append>
                
            </b-input-group>
        </b-col>

      </b-row>
        <b-table
          class="mb-0"
          ref="tblAP2" style="font-size:smaller;" 
          responsive small striped hover
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
          <template v-slot:cell(totalinv)="data">
              {{data.item.totalinv | numFormat}}
          </template>

          <template v-slot:cell(outstand)="data">
            {{data.item.outstand | numFormat}}
          </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
</template>
<style lang="scss">
  .lku-ap2 {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import apinv from "../../apis/apinv";
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      lkuLoading:false,
      fields: [
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "AP. Number",
            sortable: true
          },
          // {
          //   key: "tanggal",
          //   thStyle: "width:100px",
          //   label: "AP. Date",
          //   sortable: true
          // },
          {
            key: "vendorinfo",
            label: "Vendor/Supplier",
            thStyle: "width:220px",
            sortable: true
          },
          {
            key: "invoice",
            thStyle: "width:120px",
            label: "Invoice #",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description",
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "totalinv",
            label: "Invoice Amount",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right"
          },
          {
            key: "outstand",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right"
          },
      ],
      tblData: {
        items:[],
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'nomor',
        sortDesc: false,
        vendorcode:'',
        outstand : '1',
        tagihandp: '0'
      },
    };
  },
  props: ["outstand", "tagihandp"],
  created: async function() {
      // this.$emit('update:oustand', '1');
      // this.$emit('update:tagihandp', '0');
      this.tblData.oustand=this.oustand || '1';
      this.tblData.tagihandp=this.tagihandp || '0';
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.oustand=this.oustand || '1';
      this.tblData.tagihandp=this.tagihandp || '0';
      return await apinv.list(this.tblData);      

    },
    selectItem(item,index) {
          this.$emit("click", item);
    },
    clearFilter() {
        this.tblData.vendor= '';
        this.tblData.vendorcode=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.invoice='';
    },    
    keymonitor: function(event) {
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblAP2.refresh();
       }
    },    
    refresh() {
      this.$refs.tblAP2.refresh();
    }
  }
};
</script>
